module.exports = __webpack_public_path__ + "img/thumb-national-accounts.478bfa07.jpg";